<template>
    <svg :width="width"
         :height="height" 
         xmlns="http://www.w3.org/2000/svg" 
         viewBox="0 0 24 24"
         fill="none">
        <!-- Left side: Long text (multiple lines) -->
        <g opacity="0.6">
            <rect :fill="iconColor" x="2" y="3" width="8" height="1" rx="0.5"/>
            <rect :fill="iconColor" x="2" y="5" width="7" height="1" rx="0.5"/>
            <rect :fill="iconColor" x="2" y="7" width="8" height="1" rx="0.5"/>
            <rect :fill="iconColor" x="2" y="9" width="6" height="1" rx="0.5"/>
            <rect :fill="iconColor" x="2" y="11" width="8" height="1" rx="0.5"/>
            <rect :fill="iconColor" x="2" y="13" width="7" height="1" rx="0.5"/>
            <rect :fill="iconColor" x="2" y="15" width="8" height="1" rx="0.5"/>
            <rect :fill="iconColor" x="2" y="17" width="5" height="1" rx="0.5"/>
            <rect :fill="iconColor" x="2" y="19" width="7" height="1" rx="0.5"/>
        </g>
        
        <!-- Arrow indicating compression/summarization -->
        <path :fill="iconColor" 
              d="M12 12L14.5 9.5L14.5 10.5L16 10.5L16 13.5L14.5 13.5L14.5 14.5L12 12ZM14.5 11.5L13.5 12L14.5 12.5L14.5 11.5Z"/>
        
        <!-- Right side: Short summary (fewer lines) -->
        <g>
            <rect :fill="iconColor" x="17" y="8" width="5" height="1.5" rx="0.5"/>
            <rect :fill="iconColor" x="17" y="11" width="4" height="1.5" rx="0.5"/>
            <rect :fill="iconColor" x="17" y="14" width="5" height="1.5" rx="0.5"/>
        </g>
        
        <!-- Small sparkle to indicate AI/smart summary -->
        <g :fill="iconColor">
            <circle cx="20" cy="5" r="0.5"/>
            <path d="M19.5 4.5L20 3.5L20.5 4.5L21.5 5L20.5 5.5L20 6.5L19.5 5.5L18.5 5L19.5 4.5Z"/>
        </g>
    </svg>
</template>

<script>
export default {
    props: {
        iconName: {
            type: String,
            default: 'iconDialogSummaryAlt'
        },
        width: {
            type: [Number, String],
            default: 24
        },
        height: {
            type: [Number, String],
            default: 24
        },
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
}
</script> 